import type { WebSocketEventRouter } from '@/shared/websocket/router';
import type { QueryClient } from '@tanstack/react-query';

interface Dependencies {
  queryClient: QueryClient;
  translate: (key: string) => string;
}

export function registerMapWebSocketHandlers(router: WebSocketEventRouter, { queryClient }: Dependencies) {
  const disposers: Array<() => void> = [];

  disposers.push(
    router.on('map.object.updated', () => {
      queryClient.invalidateQueries({ queryKey: ['map', 'batch'] });
    }),
  );

  disposers.push(
    router.on('map.object.created', () => {
      queryClient.invalidateQueries({ queryKey: ['map', 'batch'] });
    }),
  );

  disposers.push(
    router.on('map.object.deleted', () => {
      queryClient.invalidateQueries({ queryKey: ['map', 'batch'] });
    }),
  );

  return () => {
    disposers.forEach((dispose) => dispose());
  };
}
